import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import TagsAnchorContainer from "../TagsAnchorContainer";
import ArticleUtile from "../ArticleUtile";
import RightPartContent from "../RightPartContent";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicEchecPaiement = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Payer une inscription', link: '/topics/paiement/payer-inscription'},
    { label: topic.title, link: topic.link},
  ]


  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Votre transaction est bloquée ? Découvrez pourquoi cela peut se produire et ce que vous pouvez faire pour 
              résoudre les problèmes de paiement.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-56" ref={anchorsParts[0].ref}>
              <p className="help-title-part mb-8">{anchorsParts[0].content}</p>
              <ul>
                <li className="pl-8 mb-16"><p className="help-text">Votre carte de crédit ou de débit a expiré.</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Le mode de paiement utilisé n'est pas accepté dans votre zone géographique.</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Vous avez dépassé le montant de transaction ou la limite d'achat quotidiens fixés par votre banque ou votre établissement financier.</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Votre carte de crédit ou de débit ne dispose pas de fonds suffisants pour effectuer le paiement.</p></li>
                <li className="pl-8 mb-16"><p className="help-text">La procédure de prévention contre la fraude a été déclenchée.</p></li>
              </ul>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part mb-8">{anchorsParts[1].content}</p>
              <ul>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    Si votre carte de débit ou de crédit a expiré, 
                    <a target='_blank' className="link" href="/topics/paiement/43">modifiez votre mode de paiement.</a>
                  </p>
                </li>
                <li className="pl-8 mb-16">
                  <p className="help-text">
                    Assurez-vous que le
                    <a target='_blank' className="link" href="/topics/paiement/42">mode de paiement est accepté dans votre zone géographique.</a>
                  </p>
                </li>
                <li className="pl-8 mb-16"><p className="help-text">Vérifiez que votre mode de paiement a été confirmé.</p></li>
                <li className="pl-8 mb-16"><p className="help-text">Contactez votre banque ou votre établissement financier pour savoir pourquoi votre carte peut être refusée.</p></li>
              </ul>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicEchecPaiement